import * as requests from '../api-request'

export const uploadFile = async (projectUuid, file) => {
  const formData = new FormData() // eslint-disable-line no-undef
  formData.append('file', file)
  formData.append('projectUuid', projectUuid)
  return requests.toJSON('POST', 'ai_knowledge/upload', formData, null, false)
}

export const getFiles = async (projectUuid) => {
  return requests.toJSON('GET', `ai_knowledge/${projectUuid}`)
}

export const getStatus = async (projectUuid) => {
  return requests.toJSON('GET', `ai_knowledge/${projectUuid}/status`)
}

export const deleteFile = async (projectUuid, fileUuid) => {
  return requests.toJSON('DELETE', `ai_knowledge/${projectUuid}/${fileUuid}`)
}
